import { ApolloClient, InMemoryCache, NormalizedCacheObject } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'
import { setContext } from '@apollo/client/link/context'

const authLink = setContext((_, { headers }) => {
  return { headers }
})

const uploadLink = createUploadLink({
  uri: `/api/v1/admin`,
})

const apolloAdminClient: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(uploadLink),
})

export default apolloAdminClient
